import './Framework/Styles/style.scss';
import React from 'react';
import LayoutProvider, {Layouts} from "./Framework/Providers/LayoutProvider";
import {Route, Routes} from "react-router-dom";
import AppRoutes from "./AppRoutes";

import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {AuthProvider} from "react-oauth2-code-pkce";
import SiteProvider from "./Providers/SiteProvider";
import UKPBAuthProvider, {authConfig} from "./Providers/AuthProvider";
import DevMenu from './Framework/Components/Actions/DevMenu';

const queryClient = new QueryClient();

function App() {
    return (
        <AuthProvider authConfig={authConfig}>
            <UKPBAuthProvider>
                <QueryClientProvider client={queryClient}>
                    <LayoutProvider defaultLayout={Layouts.CONTENT_ONLY}>
                        <SiteProvider>
                            <Routes>
                                {AppRoutes.map((route: any, index: number) => {
                                    const { element, ...rest } = route;
                                    return <Route key={`'routeMapper${index}`} {...rest} element={element} />;
                                })}
                            </Routes>
                        </SiteProvider>
                    </LayoutProvider>
                </QueryClientProvider>
            </UKPBAuthProvider>
        </AuthProvider>
    );
}

export default App;
